import { AuthService } from "../../globals/services/auth.service";
import { setupInterceptors } from "../../globals/services/axios";

export const SET_TOKEN = "SET_TOKEN";
export const LOGOUT = "LOGOUT";
export const SET_ME = "SET_ME";

export const validateEmail = (username: string) => {
    return async (dispatch: any) => {
        try {
            const authService = AuthService();
            return await authService.validateEmail(username);
        } catch (err: any) {
            throw err;
        }
    };
}



export const userLoginAction = (username: string, password: string) => {
    return async (dispatch: any) => {
        try {
            const authService = AuthService();
            return await authService.loginUser(username, password);
        } catch (err: any) {
            throw err;
        }
    };
}


export const otpLoginAction = (username: string, password: string, otp: string) => {
    return async (dispatch: any) => {
        try {
            const authService = AuthService();
            const res = await authService.loginWithOtp(username, password, otp);
            localStorage.setItem('token', res.access_token);
            setupInterceptors(); // Re-setup interceptors with new token
            dispatch({ type: SET_TOKEN, value: res.access_token });
        } catch (err) {
            throw err;
        }
    };
}

export const loginAction = (username: string, password: string) => {
    return async (dispatch: any) => {
        try {
            const authService = AuthService();
            const res = await authService.login(username, password);
            if(res.access_token){
                localStorage.setItem('token', res.access_token);
                setupInterceptors(); // Re-setup interceptors with new token
                dispatch({ type: SET_TOKEN, value: res.access_token });
            }
            return res;
        } catch (err) {
            throw err;
        }
    };
}

export const logoutAction = () => {
    try {
        console.log("Logging out, clearing token");
        const authService = AuthService();
        authService.logout();
        // Clear token from localStorage
        localStorage.removeItem('token');
        setupInterceptors(); // Re-setup interceptors without token
        return { type: LOGOUT, value: null };
    } catch (err) {
        console.error("Error during logout:", err);
        // Even if there's an error, we should still logout
        localStorage.removeItem('token');
        setupInterceptors(); // Re-setup interceptors without token
        return { type: LOGOUT, value: null };
    }
}

export const setMe = (me: any) => {
    return { type: SET_ME, value: me }
}



export const setToken = (token: string) => {
    return { type: SET_TOKEN, value: token }
}

